import React, { useState, useRef } from 'react';
import { ClickAwayListener } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

import { Input } from 'components/form/Input';
import { DotPulse } from 'components/loaders';

import {
  DropdownWrapper,
  DropdownFilterStyled,
  CaretIcon,
  Menu,
  FilterWrapper,
  ClearFilterButton,
  Options,
  Option,
} from './styledComponents';

const DropdownFilter = ({
  options = [],
  selectedOptionId,
  onSelect,
  loading,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [filterTerm, setFilterTerm] = useState('');
  const lastOption = useRef({});

  const option = options.find((option) => option.id === selectedOptionId);

  const selectedOption = option || lastOption.current;
  if (option) {
    lastOption.current = option;
  }

  const filteredOptions = filterTerm
    ? options.filter((option) =>
        option.text.toLowerCase().includes(filterTerm.toLowerCase())
      )
    : options;

  return (
    <ClickAwayListener onClickAway={() => setIsOpen(false)}>
      <DropdownWrapper>
        <DropdownFilterStyled
          onClick={() => setIsOpen(!isOpen)}
          isOpen={isOpen}
        >
          <div>{selectedOption.text}</div>
          <CaretIcon />
        </DropdownFilterStyled>
        {isOpen ? (
          <Menu>
            <FilterWrapper>
              <Input
                placeholder="Search"
                onChange={(e) => setFilterTerm(e.target.value)}
                value={filterTerm}
              />
              <ClearFilterButton onClick={() => setFilterTerm('')}>
                <FontAwesomeIcon icon={faTimes} />
              </ClearFilterButton>
            </FilterWrapper>

            {loading ? (
              <DotPulse />
            ) : (
              <Options>
                {filteredOptions.map((option) => {
                  return (
                    <Option
                      key={option.id}
                      onClick={() => {
                        setIsOpen(false);
                        onSelect(option);
                      }}
                      selected={option.id === selectedOptionId}
                    >
                      <input
                        checked={option.id === selectedOptionId}
                        type="radio"
                      />
                      {option.text}
                    </Option>
                  );
                })}
              </Options>
            )}
          </Menu>
        ) : null}
      </DropdownWrapper>
    </ClickAwayListener>
  );
};

export { DropdownFilter };
